import { Component, Input, OnDestroy, OnInit, Output, EventEmitter } from '@angular/core';
import { Observable, of, Subject, throwError } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { CompanyService } from 'src/app/_services/company.service';

@Component({
  selector: 'app-customer-data',
  templateUrl: './customer-data.component.html',
  styleUrls: ['./customer-data.component.scss']
})
export class CustomerDataComponent implements OnInit, OnDestroy {
  @Input() companyData: any;
  private readonly unsubscribe$ = new Subject<void>();
  customerName: string = '';
  customerMail: string = '';
  customerStreet: string = '';
  customerCity: string = '';
  customerState: string = '';
  customerZip: string = '';
  customerCountry: string = '';
  customerAdditionalAddress: string = '';
  customerVatNumber: string = '';

  searchFunc: any;
  // Emitted after the company data are saved so the caller can re-run the database-configuration gate.
  @Output() companyDataSaved = new EventEmitter<void>();

  countries: string[] = [
    'Austria (AT)',
    'Belgium (BE)',
    'Bulgaria (BG)',
    'Croatia (HR)',
    'Cyprus (CY)',
    'Czechia (CZ)',
    'Denmark (DK)',
    'Estonia (EE)',
    'Finland (FI)',
    'France (FR)',
    'Germany (DE)',
    'Greece (GR)',
    'Hungary (HU)',
    'Ireland (IE)',
    'Italy (IT)',
    'Latvia (LV)',
    'Lithuania (LT)',
    'Luxembourg (LU)',
    'Malta (MT)',
    'Netherlands (NL)',
    'Norway (NO)',
    'Poland (PL)',
    'Portugal (PT)',
    'Romania (RO)',
    'Slovakia (SK)',
    'Slovenia (SI)',
    'Spain (ES)',
    'Sweden (SE)',
    'Switzerland (CH)',
    'United Kingdom (GB)',
    'United States (US)',
  ];

  constructor(
    private readonly companyService: CompanyService) {}

  ngOnInit() {
    this.searchFunc = this.search.bind(this);
  }

  search(text: string): Observable<string[]> {
    if (text === 'error') {
      return throwError('failed');
    }
    return of(this.countries.filter(value => value.includes(text))).pipe(delay(1000));
  }

  disableConfirmButton(): boolean {
    if(this.customerName === '' || this.customerMail === '' || this.customerStreet === '' || this.customerCity === '' || this.customerState === '' || this.customerZip === '' || this.customerCountry === '' || (this.customerCountry !== 'United States (US)' && this.customerVatNumber === '')) {
      return true;
    } else {
      return false;
    }
  }

  sendCompanyData() {
    const body = {
      fleetId: this.companyData.fleetId,
      databaseName: this.companyData.databaseName,
      companyName: this.customerName,
      companyContactEmail: this.customerMail,
      companyAddress: {
        street: this.customerStreet,
        city: this.customerCity,
        state: this.customerState,
        zipPostalCode: this.customerZip,
        country: this.customerCountry,
      },
      additionalBillingAddress: this.customerAdditionalAddress,
      vatNumber: this.customerVatNumber,
    }
    this.companyService.updateCompanyData(body).pipe(takeUntil(this.unsubscribe$)).subscribe({
      error: (error) => {
        console.error('Error update company data:', error);
      },
      complete: () => {
        // Let the parent re-run the "is the database already configured?" gate (401/403 dialogs live there).
        this.companyDataSaved.emit();
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
